export default __webpack_public_path__ + "static/media/browsersync.fffb4283.svg";